import { lodash as _ } from '../../../common';

export const mergeEditedItem = (currentItem, editedItem) => {
   _.merge(currentItem, editedItem);

   if (editedItem && Object.prototype.hasOwnProperty.call(editedItem, 'options')) {
      currentItem.options = _.cloneDeep(editedItem.options);
   }

   return currentItem;
};

export default mergeEditedItem;
